<div class="sub-builder-holder">
  <mat-stepper [linear]="false" #stepper>

    <mat-step label="Subscription Details">
      <app-dynamic-form [stepper]="stepper" (formLoaded)="loadSubForm($event)" [valueMap]="subValueMap" [model]="'Sub'" [hideRelationships]="true" [includeFields]="subStepFields" (submitOutput)="handleSubSubmitOutput($event)"></app-dynamic-form>
    </mat-step>

    <mat-step [stepControl]="serviceAddressStepControl" label="Service Locations">
      @if (subObj) {
      <app-service-address-selector [sub]="subObj" [customer]="data.customer" (selectionChange)="handleServiceAddressSelectionChange($event)"></app-service-address-selector>
      <div class="next-button-holder">
        <button mat-fab extended matStepperNext [disabled]="serviceAddressStepControl.invalid">Next</button>
        @if (serviceAddressStepControl.invalid) {
        <p>Add at least one Service Location above before moving on to pricing.</p>
        }
      </div>
      }
    </mat-step>

    <mat-step [stepControl]="priceBuilderForm" label="Services and Pricing">
      @if (subObj){
      <app-create-subscription-dialog (formLoaded)="loadPriceBuilderForm($event)" (submitOutput)="handlePriceBuilderSubmitOutput($event)" [subObj]="subObj" [customer]="data.customer" [aggregatedServiceSelections]="aggregatedServiceSelections" [useServiceAddressSelections]="true"></app-create-subscription-dialog>
      }
      @else {
      Loading Form...
      }
    </mat-step>
  </mat-stepper>
  <!--<h2>Create a subscription for: {{data.customer.name}}</h2>-->
  <!--
  <form (ngSubmit)="onSubmit()" [formGroup]="form">
    <mat-stepper [linear]="false" #stepper>

      <mat-step [stepControl]="subForm" label="Subscription Details">
        @if (!subFormLoaded){
        <p>Loading Sub Form...</p>
        }
        <form (ngSubmit)="subFormSubmit()" [formGroup]="subForm" [hidden]="!subFormLoaded">
          <app-dynamic-form (formLoaded)="loadSubForm($event)" [valueMap]="subValueMap" [model]="'Sub'" [hideRelationships]="true" [externalHandler]="true" (submitOutput)="handleSubSubmitOutput($event)"></app-dynamic-form>
          <div class="next-button-holder">
            <button mat-fab extended matStepperNext [disabled]="!subForm.valid || !subObj">Next</button>
            @if(!subObj){<p>Save the subscription details above before moving on to pricing.</p>}
            @if(subMessage != ''){<p>{{subMessage}}</p>}
          </div>
        </form>
      </mat-step>

      <mat-step [stepControl]="priceBuilderForm" label="Services and Pricing">
        @if (subObj){
        @if (!priceBuilderFormLoaded){
        <p>Loading Price Builder Form...</p>
        }
        <form (ngSubmit)="priceBuilderSubmit()" [formGroup]="priceBuilderForm" [hidden]="!priceBuilderFormLoaded">
          <app-create-subscription-dialog (formLoaded)="loadPriceBuilderForm($event)" (submitOutput)="handlePriceBuilderSubmitOutput($event)" [hideSaveButton]="true" [externalHandler]="true" [subObj]="subObj"></app-create-subscription-dialog>
        </form>
        <div class="button-holder">
          <button mat-fab extended matStepperPrevious>Back</button>
          <button mat-fab extended [disabled]="!subForm.valid || !priceBuilderForm.valid">Submit</button>
        </div>
        }
      </mat-step>
    </mat-stepper>
  </form>
  -->
</div>